import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../context';
import type { Member } from '../types';

export function useMembers(familyId: string | undefined) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['family', familyId, 'members'],
    queryFn: () => apiClient.get<{ members: Member[] }>(`/api/families/${familyId}/members`),
    enabled: !!familyId,
  });
}
